
import Vue from "vue";
import { Script } from "@/models/script";
import AppLabel from "@/components/InfoInput.vue";
import AppTranslationInfo from "@/components/TranslationInfo.vue";

export default Vue.extend({
	props: {
		script: {
			type: Object as ()=>Script,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppTranslationInfo,
		AppLabel
	}
});
